import { CartDepartureNotFound } from "@busbud/busbud-errors";
import type {
  RelatedPublicSegment,
  RelatedPublicSegmentV4,
  RelatedPublicTrip,
  RelatedPublicTripV4
} from "@busbud/core-types/dist/lib/poll-service/api";

import { isReturn } from "@app/helpers/search";
import { getSegmentIdsPerLeg } from "@app/helpers/udm/get-segment-ids-per-leg";
import { parseLegCardIdClassAndFareHash } from "@app/helpers/udm/hashes";
import { getLegCardHashId } from "@app/modules/results/selectors/leg-cards/get-leg-cards";
import type { Features } from "@app/types/experiments";
import type { SearchInfo } from "@app/types/search-types";

export const reconciliateTripId = (
  trips: (RelatedPublicTrip | RelatedPublicTripV4)[],
  segments:
    | Record<string, RelatedPublicSegment>
    | Record<string, RelatedPublicSegmentV4>,
  leg_card_id_class_and_fare: string,
  search: SearchInfo,
  experiments: Features
) => {
  const parsed_hash = parseLegCardIdClassAndFareHash(
    leg_card_id_class_and_fare
  );

  const is_return = isReturn(search);

  const leg_direction: "return" | "outbound" = is_return
    ? "return"
    : "outbound";

  const trip = trips.find(trip => {
    const leg_card_id = getLegCardHashId(trip, segments, search, experiments);

    if (leg_card_id === parsed_hash.leg_card_id) {
      const segments_per_leg = getSegmentIdsPerLeg(trip.trip_legs);

      const segment_id =
        leg_direction === "return"
          ? // @ts-expect-error TS2532 Unsafe indexed access (noUncheckedIndexedAccess); tracked in #24591
            segments_per_leg[1][0]
          : // @ts-expect-error TS2532 Unsafe indexed access (noUncheckedIndexedAccess); tracked in #24591
            segments_per_leg[0][0];

      // @ts-expect-error TS2538 Unsafe indexed access (noUncheckedIndexedAccess); tracked in #24591
      const segment = segments[segment_id];
      // TODO: UDMV4 migrate to udmv4
      const class_xid = segment.class.xid;
      const fare_id = segment.fare_id;

      if (
        class_xid === parsed_hash.class_xid &&
        fare_id === parsed_hash.fare_id
      ) {
        return trip;
      }
    }
  });

  if (!trip) {
    throw new CartDepartureNotFound(
      buildReconciliationTripNotMatchErrorMessage(leg_direction)
    );
  }

  return trip;
};

const buildReconciliationTripNotMatchErrorMessage = (
  direction: "outbound" | "return"
) => {
  if (direction === "outbound") {
    return "RECONCILIATION_OUTBOUND_TRIP_NOT_MATCH";
  }
  return "RECONCILIATION_RETURN_TRIP_NOT_MATCH";
};
